(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('fs'), require('ramda'), require('rx'), require('bluebird'), require('chalk'), require('node-fetch'), require('cheerio')) :
  typeof define === 'function' && define.amd ? define(['exports', 'fs', 'ramda', 'rx', 'bluebird', 'chalk', 'node-fetch', 'cheerio'], factory) :
  factory((global.ThemeQA = {}), global.fs, global.R, global.rx, global.bluebird, global.chalk, global.fetch, global.cheerio)
}(this, function (exports, fs, R, rx, bluebird, chalk, fetch, cheerio) { 'use strict';

  fs = ('default' in fs ? fs['default'] : fs);
  var R__default = ('default' in R ? R['default'] : R);
  chalk = ('default' in chalk ? chalk['default'] : chalk);
  fetch = ('default' in fetch ? fetch['default'] : fetch);

  let utils__error = R.compose(console.log, chalk.bold.red);
  let utils__success = R.compose(console.log, chalk.bold.green);
  let utils__info = R.compose(console.log, chalk.underline);
  let utils__highlight = R.compose(console.log, chalk.bold.yellow);

  const providers_config__readFile = bluebird.promisify(fs.readFile);

  function getApps (path) {
    return providers_config__readFile(path, {encoding: 'utf8'})
      .then(json => JSON.parse(json))
      .then(apps => toArray(apps))
      .catch(() => utils__error('Your Appfile doesn\'t exist'));
  }

  function getAppRelease ({name, version}) {
    return getThemeConfig()
      .then(config => {
        return fetch(`https://api.myedools.com/apps/${name}/releases/${version}`, getRequestHeaders(config));
      })
      .then(res => res.json());
  }

  function getThemeConfig () {
    return providers_config__readFile('theme-config.json', {encoding: 'utf8'})
      .then(res => JSON.parse(res))
      .catch(err => utils__error('There is something wrong with your theme config file!', err));
  }

  function getRequestHeaders (config) {
    return {
      headers: {
        Authorization: `Token token=${config.token}`
    }
    };
  }

  function toArray (apps) {
    return R.map(app => ({
      name: app,
      version: apps[app]
    }), R.keys(apps));
  }

  const onlyMessages = R__default.filter(R__default.compose(R__default.not, R__default.is(Boolean)));

  function lint (html, expectations) {
    let $ = cheerio.load(html);
    return onlyMessages(R__default.map(exp => isValid($, exp), expectations));
  }

  function hasAttribute ($, {name, value}) {
    let elems = $(`[${name}]`);
    let regexp = new RegExp(escapeRegex(value));
    let matchesAttr = elem => regexp.test(elem.attribs[name]);

    return R__default.any(matchesAttr, elems);
  }

  function hasElement ($, {name, attributes}) {
    let elems = $(`${name}`);
    let matchesAllAttrs = elem => {
      let attrs = R__default.keys(elem.attribs);
      let matchesOrNoExpect = attr => {
        let regexp = new RegExp(escapeRegex(attributes[attr]));
        return !attributes[attr] || regexp.test(elem.attribs[attr]);
      };
      return R__default.all(matchesOrNoExpect, attrs);
    };

    return R__default.any(matchesAllAttrs, elems);
  }

  function escapeRegex (value = '') {
    return value
      .replace(/\(/g, '\\(')
      .replace(/\)/g, '\\)');
  }

  function isValid ($, expectation) {
    let fn = expectation.type === 'A' ? hasAttribute : hasElement;
    return fn($, expectation) ? true : renderMessage(expectation);
  }

  function renderMessage (expectation) {
    let rendered = expectation.type === 'A'
      ? renderAttribute(expectation.name, expectation.value)
      : renderElement(expectation);
    let [prefix, suffix] = expectation.message.split('{{ value }}');

    return [prefix, rendered, suffix];
  }

  function renderAttribute (name, value) {
    return `${name}="${value}"`;
  }

  function renderElement ({name, attributes}) {
    let spacer = R__default.join(' ');
    let renderedAttrs = R__default.map(attr => {
      return renderAttribute(attr, attributes[attr]);
    }, R__default.keys(attributes));

    return `<${name} ${spacer(renderedAttrs)}></${name}>`;
  }

  function consoleReporter (filename, messages) {
    if (messages && messages.length > 0) {
      utils__info(`${filename} :`);
      R.forEach(message => {
        let [prefix, target, suffix] = message;
        utils__error(prefix);
        utils__highlight(`     ${target}`);
        utils__error(suffix, '\n');
      }, messages);
    }
  }

  var console__default = consoleReporter;

  const index__readFile = bluebird.promisify(fs.readFile);

  function hasTemplates(path) {
    try {
      return fs.lstatSync(path);
    } catch (e) {
      utils__error('Your template folder doesn\'t exist');
    }
  }

  function readHTML (path) {
    return index__readFile(path, {encoding: 'utf8'});
  }

  function getTemplates ({expectations}, templatesDir) {
    let templateNames = Object.keys(expectations);

    return rx.Observable.from(templateNames)
      .flatMap(name => {
        let parsedName = `${name}.html`;
        return rx.Observable.fromPromise(readHTML(`${templatesDir}/${parsedName}`))
          .map(html => ({
            name: parsedName,
            html: html,
            expectations: expectations[name]
          }));
      });
  }

  function lintTemplate (template) {
    template.messages = lint(template.html, template.expectations);
    return template;
  }

  function validateTheme (config) {
    console.log('Linting your Edools theme...');
    if (!hasTemplates(config.templatesDir)) {
      return;
    }

    rx.Observable.fromPromise(getApps(config.appfileDir))
      .flatMap(apps => rx.Observable.from(apps))
      .filter(({name}) => name !== 'bamboo')
      .flatMap(app => rx.Observable.fromPromise(getAppRelease(app)))
      .flatMap(release => getTemplates(release, config.templatesDir))
      .map(template => lintTemplate(template))
      .reduce((templates, template) => {
        templates = templates.concat(template);
        return templates;
      }, [])
      .subscribe(templates => {
        let hasAnyMessage = R.any(({messages}) => messages.length > 0, templates);
        if (hasAnyMessage) {
          R.forEach(({name, messages}) => console__default(name, messages), templates);
          utils__error('Your theme isn\'t valid');
          process.exit(1);
        } else {
          utils__success('Your theme is valid!');
        }
      });
  }

  exports.validateTheme = validateTheme;

}));
